import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { MetricasService } from '../services/metricas.service';

const DISMISSED_KEY = 'promo_banner_dismissed';
const APPLE_APP_STORE_LINK = 'https://apps.apple.com/cl/app/simpli-factoring/id6740271087';
const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=app.simplilatam.com&pcampaignid=web_share';

@Injectable({
  providedIn: 'root',
})
export class PromoBannerService {

  constructor(private settings: SettingsService, private metricas: MetricasService) { }

  get_config() {
    return this.settings.get_query(1, 'mobile-cliente/banner/config/');
  }

  check_eligibility(company_id: string) {
    return this.settings.get_query(1, 'mobile-cliente/banner/eligibility/?company_id=' + company_id);
  }

  track_click(payload: any) {
    return this.metricas.guardarMetrica({ tipo_metrica: 'banner_click', data: payload });
  }

  is_dismissed(): boolean {
    return sessionStorage.getItem(DISMISSED_KEY) === '1';
  }

  dismiss(): void {
    sessionStorage.setItem(DISMISSED_KEY, '1');
  }

  is_apple_platform(): boolean {
    const ua = navigator.userAgent;
    const platform = navigator.platform || '';
    return /iPad|iPhone|iPod/.test(ua)
      || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      || platform.startsWith('Mac');
  }

  get_store_link(): string {
    return this.is_apple_platform() ? APPLE_APP_STORE_LINK : GOOGLE_PLAY_LINK;
  }
}
